import { ISbStoryData } from 'storyblok-js-client';

import { Locales } from '@monoimin/sb-types';

import {
  functionResultByLocales,
  getStoryAlterPathnames,
  storyHasAlternates,
} from './utils-core';

/**
 *
 * @param params - Параметры динамической или рутовой страницы.
 * @param story - Стори с полем alternate
 * @param folder - Папка, в которой находится стори
 * @param isArchive - Флаг, указывающий на то, что страница является архивной
 * @returns Возвращает объект альтернативный ссылок, который используем в next
 */
export function defineAlternatesByStory<
  T extends Omit<ISbStoryData, 'release_id'>,
  Y extends { locale: Locales }
>(params: Y, story: T, folder: string, isArchive?: boolean) {
  const locale = params.locale;

  const pathnames = getStoryAlterPathnames(story, folder);

  const languages = storyHasAlternates(pathnames)
    ? functionResultByLocales((loc) =>
        pathnames[loc] ? pathnames[loc] : undefined
      )
    : undefined;
  if (isArchive) {
    return {
      languages,
    };
  }
  return {
    canonical: pathnames[locale],
    languages,
  };
}
